<nz-modal
  [(nzVisible)]="isVisible"
  nzTitle="Tariff Code"
  (nzOnCancel)="isVisible = false"
  (nzOnOk)="handleOk()"
>
  <ng-container *nzModalContent>
    <form
      nz-form
      se-container="1"
      [formGroup]="form"
      nzLayout="vertical"
      labelWidth="150"
    >
      <se
        label="Code"
        required
        [error]="'Code is required.'"
      >
        @if (eInvoiceSrv.isEnabled) {
          <app-number-only-input
            formControlName="code"
            [maxChar]="12"
            [allowDot]="true"
          ></app-number-only-input>
        }
        @else {
          <input nz-input formControlName="code" maxlength="20" />
        }
      </se>
      <se label="Description">
        <input nz-input formControlName="description" maxlength="1000" />
      </se>
    </form>
  </ng-container>
</nz-modal>
